"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BubbleGroup = void 0;
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ToggleMenuFlyoutEvent = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _uuid = require("uuid");
var _constants = require("../../constants");
var _utils = require("../../utils");
var _Bubble = require("../Bubble");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const BubbleGroup = () => {
  const [bubbles, setBubbles] = (0, _react.useState)([]);
  const removeBasketBubble = bubbleId => {
    setBubbles(currentBubbles => currentBubbles.filter(currentBubble => currentBubble.id !== bubbleId));
  };
  const onToggleMenuFlyout = event => {
    const {
      menuType
    } = event.detail;
    if (menuType === ToggleMenuFlyoutEvent.MenuTypes.Minibag && (0, _utils.isMinibagVisible)()) {
      // hide all bubbles when minibag is being opened
      setBubbles([]);
    }
  };
  const onBasketUpdate = event => {
    // don't show bubble if not add-to-basket update or if minibag is visible
    if (!event.detail.lastAddedItem || (0, _utils.isMinibagVisible)()) {
      return;
    }
    const {
      itemCode,
      method,
      frequency
    } = event.detail.lastAddedItem;
    const {
      shoppingBagItems,
      offers
    } = event.detail.shoppingBag;
    const offersItems = offers.reduce((acc, offer) => [...acc, ...offer.items], []);

    // proper typing for method -- TODO
    const methodType = method;
    const item = methodType === BasketUpdatedEvent.LastAddedItemMethod.BUY_FOR_MONEY ? shoppingBagItems.find(product => product.itemCode === itemCode) : offersItems.find(product => product.itemCode === itemCode);
    if (!item) {
      return;
    }
    const bubble = {
      id: (0, _uuid.v4)(),
      code: item.itemCode,
      name: item.itemDescription,
      price: item.totalPrice,
      quantity: item.requestedQuantity,
      image: item.itemImageSrc,
      points: item.totalRedeemedPoints,
      frequency,
      methodType,
      nodeRef: /*#__PURE__*/(0, _react.createRef)()
    };
    setBubbles(currentBubbles => [...currentBubbles, bubble]);
    setTimeout(() => removeBasketBubble(bubble.id), _constants.bubbleDuration);
  };
  (0, _react.useEffect)(() => {
    window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdate);
    window.addEventListener(ToggleMenuFlyoutEvent.Name, onToggleMenuFlyout);
    return () => {
      window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdate);
      window.removeEventListener(ToggleMenuFlyoutEvent.Name, onToggleMenuFlyout);
    };
  });
  const timeoutSettings = {
    appear: 0,
    enter: 0,
    exit: 1250
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BasketBubbleWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTransitionGroup.TransitionGroup, {
      children: bubbles.map(({
        id,
        nodeRef,
        ...bubble
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTransitionGroup.Transition, {
        nodeRef: nodeRef,
        timeout: timeoutSettings,
        children: state => {
          const bubbleOwnerState = {
            state
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AnimationWrapper, {
            ref: nodeRef,
            ownerState: bubbleOwnerState,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Bubble.Bubble, {
              ...bubble
            }, id)
          }, id);
        }
      }, id))
    })
  });
};
exports.BubbleGroup = BubbleGroup;